export const CURRENT_PLATFORM = "web";
